<template>
  <div class="zhanwei4"></div>
  <div class="next">
    <h1>{{ "标题：" + form.levelTitle }}</h1>
    <div class="btns">
      <el-button
        size="large"
        @click="$router.back(-1)"
        style="background: #f5f7fa; color: #000"
      >
        <el-icon><ArrowLeftBold /></el-icon> &nbsp;&nbsp;{{
          $t("Detail.back")
        }}</el-button
      >
      <el-button
        size="large"
        @click="submitForm('ruleForm')"
        style="background: #4f4f4f; color: #fff"
      >
        <el-icon><DocumentChecked /></el-icon> &nbsp;&nbsp;{{
          $t("Detail.save")
        }}</el-button
      >
    </div>
  </div>
  <el-segmented
    v-model="value"
    :options="options"
    block
    size="large"
    class="selectBar"
  />
  <div class="zhanwei4"></div>
  <div class="answer">
    <form1 v-show="value == '故事脚本'" ref="form1" :dataForm="form"></form1>
    <form2 v-show="value == '关卡设计'" ref="form2" :dataForm="form"></form2>
    <form3 v-show="value == '提示'" ref="form3" :dataForm="form"></form3>
    <form4 v-show="value == '景点知识'" ref="form4" :dataForm="form"></form4>
    <form5
      v-show="value == '地点导航'"
      ref="form5"
      :dataForm="form"
      :dataForm2="form2"
    ></form5>
    <!--    <form6 v-show="value == '游戏复盘'" ref="form6" :dataForm="form"></form6>-->
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, ref } from "vue";
import { ArrowLeftBold, DocumentChecked, Plus } from "@element-plus/icons-vue";
import type { FormRules, UploadProps, UploadUserFile } from "element-plus";
import { detailForm } from "@/views/view";
import form1 from "@/components/detail/component/form1.vue";
import form2 from "@/components/detail/component/form2.vue";
import form3 from "@/components/detail/component/form3.vue";
import form4 from "@/components/detail/component/form4.vue";
import form5 from "@/components/detail/component/form5.vue";
import form6 from "@/components/detail/component/form6.vue";
import { ElMessage } from "element-plus";
const validateNotEmpty = (rule: any, value: string, callback: any) => {
  if (value.trim() === "") {
    callback(new Error(rule.message));
  } else {
    callback();
  }
};

export default defineComponent({
  name: "App",
  data() {
    const form: any = {
      id: "",
      levelTitle: "",
      levelContent: "",
      difficulty: 1,
      storyTitle: "",
      storyContent: "",
      clues: "",
      answers: "",
      tipTitle: "",
      tipContent: "",
      belongId: "",
      createTime: "",
      updateTime: null,
      gameLevelId: "",
    };
    return {
      form,
      form2: {
        mapSelect: "",
        customizeMap: "",
      },
      fileList: ref<UploadUserFile[]>([]),
      dialogImageUrl: "",
      dialogVisible: false,
      rules: reactive<FormRules>({
        levelTitle: [
          {
            required: true,
            message: "关卡标题不能为空",
            trigger: "blur",
            validator: validateNotEmpty,
          },
        ],
        levelContent: [
          {
            required: true,
            message: "P关卡谜题内容不能为空",
            trigger: "blur",
            validator: validateNotEmpty,
          },
        ],
        storyTitle: [
          {
            required: true,
            message: "故事标题不能为空",
            trigger: "blur",
            validator: validateNotEmpty,
          },
        ],
        storyContent: [
          {
            required: true,
            message: "故事内容不能为空",
            trigger: "blur",
            validator: validateNotEmpty,
          },
        ],
        answers: [
          {
            required: true,
            message: "谜题答案不能为空",
            trigger: "blur",
            validator: validateNotEmpty,
          },
        ],
      }),
      options: [
        "地点导航",
        "故事脚本",
        "关卡设计",
        "提示",
        "景点知识",
        // "游戏复盘",
      ],
      value: "地点导航",
    };
  },
  components: {
    DocumentChecked,
    Plus,
    ArrowLeftBold,
    form1,
    form2,
    form3,
    form4,
    form5,
    form6,
  },
  computed: {
    UpdateApi() {
      return process.env.VUE_APP_Update_API;
    },
  },
  watch: {},
  mounted() {
    const { id, detailId } = this.$route.params;
    this.id = detailId;
    const { games } = this.$store.state.game;

    if (id !== 0) {
      const game = games.find((item: any) => item.id === id);

      if (game && game.gameLevelId) {
        this.gameLevelId = game.gameLevelId;
      }

      if (game.mapSelect === "自定义地图" && game.customizeMap) {
        this.form2.customizeMap = game.customizeMap;
        this.form2.mapSelect = game.mapSelect;
      }
    }
    this.$store
      .dispatch("game/getLevelDetail", { levelId: this.$route.params.detailId })
      .then((res: any) => {
        this.form = res.levelInfo;
        if (res.levelInfo.arrows) {
          localStorage.setItem("generatedImages", res.levelInfo.arrows);
        } else {
          localStorage.setItem("generatedImages", "");
        }
      })
      .catch(() => {});
  },
  methods: {
    submitForm(formName) {
      const a = this.$refs["form1"].$data.form;
      const b = this.$refs["form2"].$data.form;
      // const c = this.$refs["form3"].$data.form;
      const d = this.$refs["form4"].$data.form;
      const e = this.$refs["form5"].$data.form;
      const f = this.$refs["form6"].$data.form;

      let arrows =
        localStorage.getItem("generatedImages") != "null"
          ? localStorage.getItem("generatedImages")
          : "";

      let form = {
        ...a,
        ...b,
        ...d,
        ...e,
        // ...f,
        id: this.id,
        arrows: arrows,
      };

      if (!a.storyCover || !a.storyDesc || !a.storyTitle) {
        this.value = "故事脚本";
        ElMessage.warning({
          message: "故事脚本未完成",
        });
        return;
      } else if (!b.levelTitle || !b.region) {
        this.value = "关卡设计";
        ElMessage.warning({
          message: "关卡设计未完成",
        });
        return;
      } else if (!e.address || e.lat == 0 || e.lng == 0) {
        this.value = "地点导航";
        ElMessage.warning({
          message: "地点导航未完成",
        });
        return;
      }
      this.$store
        .dispatch("game/saveLevel", {
          levelBean: form,
        })
        .then((res: any) => {
          this.$refs["form3"].saveTip();
          this.$store.dispatch("game/getGameLevelList", {
            gameLevelId: this.gameLevelId,
          });
        });
    },
    handlePictureCardPreview(uploadFile: any): UploadProps["onPreview"] | void {
      this.dialogImageUrl = uploadFile.url!;
      this.dialogVisible = true;
    },
    handleRemove(
      uploadFile: any,
      uploadFiles: any
    ): UploadProps["onRemove"] | void {
      console.log(uploadFile, uploadFiles);
    },
  },
});
</script>

<style lang="less" scoped>
@import "@/static/less/detail";
</style>
